<template>
  <div class="c-policy g-container">
    <Spin size="large" fix v-if="!show" />
    <moduler name="policy_add" :title="title">
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">策略名称</span>
        </Col>
        <Col span="12">
          <input-len v-model="policy.name" placeholder="最大40个字符，1个中文等于2个字符" :max="40" width="360"></input-len>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">游戏平台</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.ch_platform_id" type="button" @on-change="gameChange">
            <Radio :label="1" :disabled="editState">Android</Radio>
            <Radio :label="2" :disabled="editState">iOS</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">游戏组</span>
        </Col>
        <Col span="12">
          <auto-complete v-model="policy.group" :data="groupList" placeholder="全部" style="width: 360px" @on-select="handleGroup" />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">游戏（可多选）</span>
        </Col>
        <Col span="12">
          <Select v-model="policy.game" multiple filterable style="width: 360px" @on-change="clearGame">
            <Option v-for="item in gamePlatformList" :key="item.id" :value="item.id">
              {{ item.name }}
            </Option>
          </Select>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">投放范围</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.delivery_range" type="button" @on-change="changeDelivery">
            <Radio label="DEFAULT">默认</Radio>
            <Radio label="UNION">穿山甲(联盟)</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="policy.delivery_range === 'UNION'">
        <Col span="3" class="col-item">
          <span class="item-field">投放形式</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.union_video_type" type="button">
            <Radio label="REWARDED_VIDEO">激励视频</Radio>
            <Radio label="ORIGINAL_VIDEO">原生视频</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="policy.delivery_range === 'DEFAULT'">
        <Col span="3" class="col-item">
          <span class="item-field">搜索快投</span>
        </Col>
        <Col span="12" class="col-flex">
          <i-Switch
            v-model="policy.feed_delivery_search"
            :disabled="policy.delivery_range === 'UNION'"
            true-value="HAS_OPEN"
            false-value="DISABLED"
          />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">投放方式</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.download_type" type="button">
            <Radio label="DOWNLOAD_URL">APP应用</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">投放目标</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.ad" type="button">
            <Radio label="CONVERSION">转化量</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">事件管理优化目标</span>
        </Col>
        <Col span="12">
          <Select v-model="policy.convert_id" style="width: 360px" placeholder="请选择优化目标">
            <Option v-for="item in convertData" :value="item.key" :key="item.key">{{ item.value }}</Option>
          </Select>
        </Col>
      </Row>
    </moduler>

    <moduler name="policy_out" title="预算及出价">
      <!-- <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">出价方式</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.smart_bid_type" type="button" @on-change="smartBidChange">
            <Radio label="SMART_BID_CUSTOM">手动出价</Radio>
            <Radio label="SMART_BID_CONSERVATIVE">自动出价</Radio>
          </RadioGroup>
        </Col>
      </Row> -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">投放场景</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.smart_bid_type" type="button" @on-change="smartBidChange">
            <Radio label="SMART_BID_CUSTOM" :disabled="policy.ad !== 'CONVERSION'">常规投放</Radio>
            <Radio label="SMART_BID_CONSERVATIVE" :disabled="policy.ad !== 'CONVERSION'">放量投放</Radio>
            <Radio label="SMART_BID_NO_BID" :disabled="policy.ad !== 'CONVERSION' || policy.delivery_range === 'UNION'">最大转化投放</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="policy.ad === 'CONVERSION'">
        <!-- v-if="policy.smart_bid_type === 'SMART_BID_CONSERVATIVE' && policy.ad === 'CONVERSION'"-->
        <Col span="3" class="col-item">
          <span class="item-field">出价方式</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.adjust_cpa" type="button" @on-change="changeAdjustCpa">
            <Radio :label="1" :disabled="policy.smart_bid_type === 'SMART_BID_NO_BID'">手动出价</Radio>
            <Radio :label="0" :disabled="policy.smart_bid_type === 'SMART_BID_CONSERVATIVE' || policy.smart_bid_type === 'SMART_BID_CUSTOM'"
              >自动出价</Radio
            >
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">预算</span>
        </Col>
        <Col span="12">
          <Input v-model="policy.budget" placeholder="" style="width: 267px">
            <Select v-model="policy.budget_mode" slot="prepend" style="width: 80px">
              <Option value="BUDGET_MODE_DAY">日预算</Option>
              <Option value="BUDGET_MODE_TOTAL" disabled>总预算</Option>
            </Select>
            <span slot="append">元</span>
          </Input>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">投放时间</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.schedule_type" type="button">
            <Radio label="SCHEDULE_FROM_NOW">从今天起长期投放</Radio>
            <Radio label="SCHEDULE_START_END">设置开始和结束日期</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row v-if="policy.schedule_type === 'SCHEDULE_START_END'" class="row-item" :gutter="12">
        <Col span="3">&nbsp;</Col>
        <Col span="12">
          <Row v-if="editState">
            <Col span="24">
              <DatePicker type="date" :value="policy.start_time" disabled placeholder="请选择开始日期" style="width: 200px"></DatePicker>
              <span class="split-line"> —— </span>
              <DatePicker
                type="date"
                :value="policy.end_time"
                :options="{ disabledDate: datetimeOption.disabledDate }"
                @on-change="changeEndTime"
                placeholder="请选择结束日期"
                style="width: 200px"
              ></DatePicker>
            </Col>
          </Row>
          <DatePicker
            v-else
            type="daterange"
            :value="datetime"
            :options="datetimeOption"
            @on-change="changeDatetime"
            placeholder="请选择投放时间"
            style="width: 267px"
          />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">投放时段</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.time_range" type="button" @on-change="clearWeektime">
            <Radio label="NONE">不限</Radio>
            <Radio label="RANGE">指定时间段</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row v-if="policy.time_range === 'RANGE'" class="row-item" :gutter="12">
        <Col span="3">&nbsp;</Col>
        <Col span="12">
          <drag-weektime v-model="mult_timeRange" :data="weektimeData" @on-clear="clearWeektime"></drag-weektime>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">竞价策略</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.flow_control_mode" type="button">
            <Radio label="FLOW_CONTROL_MODE_FAST">优先跑量</Radio>
            <Radio
              label="FLOW_CONTROL_MODE_BALANCE"
              v-if="policy.ad === 'CONVERSION'"
              :disabled="policy.smart_bid_type === 'SMART_BID_NO_BID' || policy.smart_bid_type === 'SMART_BID_CONSERVATIVE'"
              >均衡投放</Radio
            >
            <Radio
              label="FLOW_CONTROL_MODE_SMOOTH"
              :disabled="policy.smart_bid_type === 'SMART_BID_NO_BID' || policy.smart_bid_type === 'SMART_BID_CONSERVATIVE'"
              >优先低成本</Radio
            >
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">付费方式</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.pricing" type="button">
            <Radio label="PRICING_OCPM">按转化付费OCPM</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <!-- <Row class="row-item" :gutter="12" v-if="policy.smart_bid_type === 'SMART_BID_CONSERVATIVE'">
        <Col span="3" class="col-item">
          <span class="item-field">预期成本</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.adjust_cpa" type="button" @on-change="changeAdjustCpa">
            <Radio :label="0">系统自动推荐</Radio>
            <Radio :label="1">手动设置</Radio>
          </RadioGroup>
        </Col>
      </Row> -->
      <Row class="row-item" :gutter="12" v-if="this.policy.adjust_cpa">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">目标转化出价</span>
        </Col>
        <Col span="16">
          <RadioGroup v-model="policy.bid_range" type="button" @on-change="changeBidRange">
            <Radio :label="0">固定金额</Radio>
            <Radio :label="1">随机金额</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="conservative && policy.bid_range">
        <Col span="3" class="col-item">&nbsp;</Col>
        <Col span="12">
          <input-range v-model="policy.bid_num_range" :precision="2" :min="0" :max="10000" placeholder="金额" />
          <span style="padding-left: 8px">元</span>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-else-if="conservative">
        <Col span="3" class="col-item">&nbsp;</Col>
        <Col span="12">
          <Input
            v-model="policy.cpa_bid"
            @on-blur="inputTrim('cpa_bid', policy.cpa_bid, policy, true)"
            placeholder="金额"
            style="width: 100px"
          />
          <span style="padding-left: 8px">元</span>
        </Col>
      </Row>
      <!-- 深度优化方式 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">深度优化方式</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.deep_bid_type" type="button" @on-change="changeDeepBid">
            <Radio label="DEEP_BID_DEFAULT">无深度优化</Radio>
            <Radio label="DEEP_BID_PACING" v-if="policy.smart_bid_type === 'SMART_BID_CUSTOM'">自动优化</Radio>
            <Radio label="DEEP_BID_MIN" v-if="policy.smart_bid_type === 'SMART_BID_CUSTOM'">自定义双出价</Radio>
            <Radio
              label="SMARTBID"
              v-if="policy.smart_bid_type !== 'SMART_BID_CUSTOM'"
              :disabled="policy.smart_bid_type === 'SMART_BID_NO_BID'"
              >自动优化</Radio
            >
            <Radio
              label="AUTO_MIN_SECOND_STAGE"
              v-if="policy.smart_bid_type !== 'SMART_BID_CUSTOM'"
              :disabled="policy.smart_bid_type === 'SMART_BID_NO_BID' || policy.delivery_range === 'UNION'"
              >自定义双出价</Radio
            >
            <Radio label="ROI_COEFFICIENT">ROI系数</Radio>
            <Radio label="ROI_PACING">ROI自动优化</Radio>
            <Radio label="BID_PER_ACTION">每次付费出价</Radio>
          </RadioGroup>
          <span v-if="policy.deep_bid_type === 'ROI_COEFFICIENT'">
            <span style="color: #ff4400; margin-top: 6px; display: block">提示：ROI优化功能为白名单功能，请确定账号功能是否开通！！！</span>
            <span style="color: #ff4400; margin-top: 6px; display: block"
              >【转化追踪】必须选择付费且深度转化为ROI系数，否则会报错！！！</span
            >
          </span>
          <span v-if="policy.deep_bid_type === 'BID_PER_ACTION'">
            <span style="color: #ff4400; margin-top: 6px; display: block"
              >提示：每次付费功能为白名单功能，请确定账号功能是否开通！！！</span
            >
            <span style="color: #ff4400; margin-top: 6px; display: block">【转化追踪】必须选择付费，否则会报错！！！</span>
          </span>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="policy.deep_bid_type === 'ROI_COEFFICIENT' && policy.smart_bid_type !== 'SMART_BID_NO_BID'">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">ROI系数</span>
        </Col>
        <Col span="12">
          <Input
            v-model="policy.roi_goal"
            @on-blur="inputTrimFour('roi_goal', policy.roi_goal, policy, true)"
            placeholder="请输入ROI系数，ROI系数不大于5，保留小数点后四位"
            style="width: 320px"
          />
          <span style="color: #ccc; margin-top: 6px; display: block">在本次投放活动中，ROI系数 = 计划投放收益/计划投放成本</span>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="policy.deep_bid_type === 'DEEP_BID_MIN' || policy.deep_bid_type === 'AUTO_MIN_SECOND_STAGE'">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">深度转化出价</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.deep_cpabid_range" type="button" @on-change="changeDeepCpabidRange">
            <Radio :label="0">固定金额</Radio>
            <Radio :label="1">随机金额</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row
        class="row-item"
        :gutter="12"
        v-if="(policy.deep_bid_type === 'DEEP_BID_MIN' || policy.deep_bid_type === 'AUTO_MIN_SECOND_STAGE') && policy.deep_cpabid_range"
      >
        <Col span="3" class="col-item">&nbsp;</Col>
        <Col span="12">
          <input-range v-model="policy.deep_cpabid_num_range" :precision="2" :min="0" :max="10000" placeholder="金额" />
          <span style="padding-left: 8px">元</span>
        </Col>
      </Row>
      <Row
        class="row-item"
        :gutter="12"
        v-else-if="policy.deep_bid_type === 'DEEP_BID_MIN' || policy.deep_bid_type === 'AUTO_MIN_SECOND_STAGE'"
      >
        <Col span="3" class="col-item">&nbsp;</Col>
        <Col span="12">
          <Input
            v-model="policy.deep_cpabid"
            @on-blur="inputTrim('deep_cpabid', policy.deep_cpabid, policy, true)"
            placeholder="金额"
            style="width: 100px"
          />
          <span style="padding-left: 8px">元</span>
        </Col>
      </Row>
    </moduler>

    <!-- 创意信息 -->
    <moduler name="policy_creative" title="创意信息">
      <Row v-if="!hideInventory" class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">投放位置</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.inventory" type="button" @on-change="setSmart">
            <Radio label="POSITION_AD">优选投放位</Radio>
            <Radio label="POSITION_MEDIA">按媒体指定位置</Radio>
            <Radio label="POSITION_SCREEN" disabled>按场景指定位置</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row v-if="!hideInventory && policy.inventory === 'POSITION_MEDIA'" class="row-item" :gutter="12">
        <Col span="3">&nbsp;</Col>
        <Col span="18">
          <CheckboxGroup v-model="policy.inventory_type">
            <Checkbox label="INVENTORY_FEED">头条信息流</Checkbox>
            <!-- 接口下线枚举<Checkbox label="INVENTORY_TEXT_LINK">头条文章详情页</Checkbox> -->
            <Checkbox label="INVENTORY_VIDEO_FEED">西瓜信息流</Checkbox>
            <!-- <Checkbox label="INVENTORY_HOTSOON_FEED">火山信息流</Checkbox> -->
            <Checkbox label="INVENTORY_AWEME_FEED">抖音信息流</Checkbox>
            <Checkbox label="INVENTORY_UNION_SLOT">穿山甲</Checkbox>
            <Checkbox label="UNION_BOUTIQUE_GAME">穿山甲精选休闲游戏</Checkbox>
            <Checkbox label="INVENTORY_TOMATO_NOVEL">番茄小说</Checkbox>
          </CheckboxGroup>
        </Col>
      </Row>
      <Row v-if="!hideInventory && policy.inventory === 'POSITION_SCREEN'" class="row-item" :gutter="12">
        <Col span="3">&nbsp;</Col>
        <Col span="14">
          <RadioGroup v-model="policy.scene_inventory">
            <Radio label="VIDEO_SCENE">沉浸式竖版视频场景</Radio>
            <Radio label="FEED_SCENE">信息流场景</Radio>
            <Radio label="TAIL_SCENE">视频后贴和尾帧场景</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">创意分类</span>
        </Col>
        <Col span="12">
          <category :title="['创意分类']" :value="policy.mult_categroy" :data="categroyData" @on-select="selectCategroy"></category>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <Poptip
            trigger="hover"
            placement="top-start"
            width="410"
            word-wrap
            content="请提供若干准确的词语，描述您的计划主针对的产品或服务的属性。长期将非常有助于提高计划预估点击率的精准性。如金融保险的基金，可以通过基金品牌、风险等级、金融服务等方面的描述，越全面、精准、效果越好。例如：XX基金，中高风险，股票型。"
          >
            <Icon type="md-help-circle" size="18" color="#e3e3e3" />
          </Poptip>
          <span class="item-field row-item-must">创意标签</span>
        </Col>
        <Col span="12">
          <add-tags v-model="policy.ad_keywords" :open-id="opId" @on-close="closeTag"></add-tags>
        </Col>
      </Row>

      <Row v-if="appType" class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <Poptip
            trigger="hover"
            placement="top-start"
            width="410"
            word-wrap
            content="用户点击计划中“立即下载”按钮以外的区域时所到达的页面"
          >
            <Icon type="md-help-circle" size="18" color="#e3e3e3" />
          </Poptip>
          <span class="item-field row-item-must">应用下载详情页</span>
        </Col>
        <Col span="12">
          <Input v-model="policy.web_url" placeholder="建议填写橙子建站链接地址，否则可能创意建立不成功" />
          <span style="color: #ff4400; margin-top: 6px; display: inline-block"
            >注意：批量建创意时，创意使用的是这同一个下载详情页，创意成功后记得单独去修改</span
          >
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">应用名</span>
        </Col>
        <Col span="12"><input-len v-model="policy.app_name" :max="20" placeholder="4-20个字符,中文占两个字符" /></Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">副标题</span>
        </Col>
        <Col span="12">
          <Input v-model="policy.sub_title" placeholder="请输入附加创意区标题，限12字以内" />
          <div class="row-item-control">
            <Checkbox v-model="policy.is_comment_disable" :true-value="1" :false-value="0">关闭计划评论（抖音暂不支持）</Checkbox>
          </div>
          <div class="row-item-control">
            <Checkbox v-model="policy.close_video_detail" :true-value="1" :false-value="0">
              关闭视频详情页落地页
              <Poptip
                trigger="hover"
                placement="top-start"
                width="410"
                word-wrap
                content="勾选该选项后，视频详情页中不默认弹出落地页，仅对视频计划生效"
              >
                <Icon type="md-help-circle" size="18" color="#e3e3e3" />
              </Poptip>
            </Checkbox>
          </div>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" style="margin-bottom: 14px">
        <Col span="3" class="col-item">
          <span class="item-field">创意展现方式</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="policy.creative_display_mode" type="button">
            <Radio label="CREATIVE_DISPLAY_MODE_CTR">优选模式</Radio>
            <Radio label="CREATIVE_DISPLAY_MODE_RANDOM">轮播模式</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3">&nbsp;</Col>
        <Col span="14">
          <span v-if="policy.creative_display_mode === 'CREATIVE_DISPLAY_MODE_CTR'"
            >选择优选模式，系统会自动对效果好的创意进行展示量倾斜，创意效果越好展示量越高</span
          >
          <span v-else>使用创意轮播，系统将平分各创意展现量，便于计划主比较各创意投放效果</span>
        </Col>
      </Row>
    </moduler>

    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" v-if="modifieState" :loading="loading" @click.stop="save">
            <span v-if="!loading">保存规则</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submit">
            <span v-if="!loading">新增规则</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { isArray, isEmpty, trim, splicing, pullKeys, formatDate, dateReplace, timeout } from '@/common/js/utils'
import validMixin from '../mixins/valid-mixin'

import shortcuts from '@/data/toutiao/shortcuts'
import weektimeData from '@/data/toutiao/weektime_data'
import categroyData from '@/data/toutiao/ad_categroy'
import convertData from '@/data/toutiao/convert_data'

import Moduler from '@/components/moduler.vue'
import Category from '@/components/select/category.vue'
import AddTags from '@/components/add-tags.vue'
import ErrorPop from '@/components/error-pop.vue'
import InputLen from '@/components/input/input-len.vue'
import InputRange from '@/components/input/input-number-range'
import AutoComplete from '@/components/autocomplete/autocomplete.vue'
import DragWeektime from '@/components/drag/drag-weektime.vue'

import { getPtomGroupGames, getPtomGames } from '@/api/material.model'
import { getPolicy, addPolicy, editPolicy } from '@/api/manage.model'

const disabledDate = (date) => {
  return date && date.valueOf() < Date.now() - 86400000
}

// 处理7*48位值
const getWeektime = (val) => {
  return val
    .map((item) => {
      return item.child.map((ret) => (ret.check ? '1' : '0')).join('')
    })
    .join('')
}

export default {
  name: 'policyadd',
  mixins: [validMixin],
  components: { Moduler, Category, AddTags, ErrorPop, InputLen, InputRange, AutoComplete, DragWeektime },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    modifieState() {
      return this.editState && this.$route.query.id
    },
    title() {
      return this.editState ? '修改策略规则' : '新增策略规则'
    },
    gamePlatformList() {
      return this.gameList.filter((ret) => ret.ch_platform_id === this.policy.ch_platform_id)
    },
    mult_timeRange() {
      return this.weektimeData.map((ret) => {
        return {
          id: ret.row,
          week: ret.value,
          value: splicing(ret.child)
        }
      })
    },
    conservative() {
      return (
        this.policy.smart_bid_type === 'SMART_BID_CUSTOM' ||
        (this.policy.smart_bid_type === 'SMART_BID_CONSERVATIVE' && this.policy.adjust_cpa)
      )
    },
    hideInventory() {
      return this.policy.delivery_range === 'UNION'
    },
    appType() {
      return this.policy.ch_platform_id === 1
    }
  },
  methods: {
    getData(id) {
      getPolicy({ id }).then((data) => {
        this.show = true
        if (data) {
          const { strategyName, platform, gameIdList, convertIndex, outerPlanParam, creativeParam } = data
          if (!creativeParam.third_industry_id || creativeParam.ad_category) creativeParam.mult_categroy = []
          this.policy.name = strategyName
          this.policy.ch_platform_id = platform
          this.policy.game = gameIdList
          this.policy.convert_id = convertIndex
          Object.assign(this.policy, outerPlanParam)
          Object.assign(this.policy, creativeParam)
          // 时间段反编译
          const scheduleStat =
            this.policy.schedule_time.split('').every((ret) => ret === '1') ||
            this.policy.schedule_time.split('').every((ret) => ret === '0')
          if (!scheduleStat) {
            this.policy.time_range = 'RANGE'
            this.reverWeektime(this.policy.schedule_time)
          }
        }
      })
    },
    reverWeektime(schedule) {
      let idx = 0
      for (let i = 0; i < this.weektimeData.length; i++) {
        const children = this.weektimeData[i].child
        for (let j = 0; j < children.length; j++) {
          const n = schedule.substr(idx, 1)
          this.$set(this.weektimeData[i].child[j], 'check', Boolean(parseInt(n)))
          idx++
        }
      }
    },
    handleGroup(meta) {
      this.policy.group = meta.id
      this.groupState = false
      if (meta.children) {
        this.policy.game = meta.children.map((ret) => parseInt(ret))
        timeout(500).then(() => {
          this.groupState = true
        })
      }
    },
    clearGame() {
      if (this.groupState) {
        this.policy.group = ''
        this.groupState = false
      }
    },
    gameChange(val) {
      this.policy.game = []
      if (val === 1) {
        this.policy.app_type = 'APP_ANDROID'
        this.policy.platform = 'ANDROID'
        this.policy.web_url = ''
      } else if (val === 2) {
        this.policy.app_type = 'APP_IOS'
        this.policy.platform = 'IOS'
        this.policy.web_url = undefined
      }
    },
    clearWeektime() {
      this.weektimeData.forEach((item) => {
        item.child.forEach((t) => {
          this.$set(t, 'check', false)
        })
      })
    },
    changeEndTime(val) {
      this.policy.end_time = formatDate(new Date(val), 'yyyy-MM-dd 23:59')
    },
    changeDatetime(val) {
      const start = dateReplace(val[0])
      const end = dateReplace(val[1])
      this.policy.start_time = formatDate(start, 'yyyy-MM-dd 00:00')
      this.policy.end_time = formatDate(end, 'yyyy-MM-dd 23:59')
    },
    changeDelivery(val) {
      if (val === 'UNION') {
        this.policy.union_video_type = 'REWARDED_VIDEO'
        this.policy.feed_delivery_search = 'DISABLED'
        this.policy.inventory = 'POSITION_MEDIA'
        this.policy.inventory_type = ['INVENTORY_UNION_SLOT']
        this.policy.smart_inventory = 0
      } else {
        this.policy.union_video_type = undefined
        this.policy.inventory = 'POSITION_AD'
        this.policy.inventory_type = []
        this.policy.smart_inventory = 1
      }
    },
    smartBidChange(val) {
      this.policy.adjust_cpa = this.policy.smart_bid_type === 'SMART_BID_NO_BID' ? 0 : 1
      this.policy.deep_cpabid = ''
      this.policy.cpa_bid = ''
      this.policy.budget = ''
      this.policy.bid_range = 0
      this.policy.deep_cpabid_range = 0
      this.policy.deep_bid_type = 'DEEP_BID_DEFAULT'
      this.policy.schedule_type = 'SCHEDULE_FROM_NOW'
      this.policy.flow_control_mode = 'FLOW_CONTROL_MODE_FAST'
    },
    changeAdjustCpa() {
      this.policy.cpa_bid = ''
      this.policy.bid_range = 0
    },
    changeBidRange() {
      this.policy.bid_num_range = ['', '']
      this.policy.cpa_bid = ''
    },
    changeDeepBid(val) {
      if (val === 'DEEP_BID_MIN' || val === 'AUTO_MIN_SECOND_STAGE') this.policy.deep_cpabid = ''
      else this.policy.deep_cpabid = undefined
    },
    changeDeepCpabidRange() {
      this.policy.deep_cpabid_num_range = ['', '']
      this.policy.deep_cpabid = ''
    },
    setSmart(val) {
      if (val === 'POSITION_AD') {
        // 优选广告位
        this.policy.smart_inventory = 1
        this.policy.inventory_type = []
        this.policy.scene_inventory = undefined
      } else if (val === 'POSITION_SCREEN') {
        // 按媒体指定位置
        this.policy.smart_inventory = 0
        this.policy.scene_inventory = ''
        if (!this.policy.inventory_type.length) this.policy.inventory_type = ['INVENTORY_FEED']
      } else {
        this.policy.smart_inventory = 0
        this.policy.scene_inventory = undefined
      }
    },
    selectCategroy(item) {
      this.$set(this.policy, 'mult_categroy', item)
    },
    closeTag(name) {
      const index = this.policy.ad_keywords.findIndex((ret) => ret === name)
      if (index > -1) this.policy.ad_keywords.splice(index, 1)
    },
    proload() {
      const { id } = this.$route.query
      Promise.all([getPtomGames(), getPtomGroupGames()])
        .then((data) => {
          const [game, group] = data
          isArray(game) && (this.gameList = game)
          if (isArray(group)) {
            this.groupList = group.map((ret) => {
              return {
                id: ret.groupId,
                name: ret.groupName,
                children: ret.gameIds
              }
            })
          }
          if (id) this.getData(id)
          else this.show = true
        })
        .catch((err) => {
          this.$Message.error(err)
        })
    },
    inputTrim(key, val, obj, fixed) {
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = parseFloat(val) * 100
        val = Math.floor(val) / 100
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    },
    customValid(params) {
      const err = []
      const {
        cpa_bid,
        bid_range,
        bid_num_range,
        deep_cpabid_range,
        deep_cpabid_num_range,
        deep_bid_type,
        budget,
        adjust_cpa,
        schedule_type,
        start_time,
        end_time,
        smart_bid_type
      } = params
      if (budget < 300) err.push({ feild: '日预算', msg: '应大于300元' })

      if (budget < cpa_bid) err.push({ feild: '预算与出价', msg: '出价应小于预算' })

      // 随机出价
      if (bid_range) {
        const [min, max] = bid_num_range
        if (budget < max) err.push({ feild: '预算与出价', msg: '出价应小于预算' })
        if (isEmpty(min) || isEmpty(max)) err.push({ feild: '目标转化出价', msg: '随机目标转化出价不能为空' })
        else if (!(adjust_cpa === 0) && (min < 0.1 || max > 10000)) err.push({ feild: '转化出价', msg: '出价范围：0.1~10000（元）' })
      } else if (!(adjust_cpa === 0) && (cpa_bid < 0.1 || cpa_bid > 10000)) {
        err.push({ feild: '转化出价', msg: '出价范围：0.1~10000（元）' })
      }

      // 随机深度出价
      if (deep_cpabid_range && (deep_bid_type === 'DEEP_BID_MIN' || deep_bid_type === 'AUTO_MIN_SECOND_STAGE')) {
        const [min, max] = deep_cpabid_num_range
        if (isEmpty(min) || isEmpty(max)) err.push({ feild: '深度转化出价', msg: '随机深度转化出价不能为空' })
      } else if (deep_bid_type === 'ROI_COEFFICIENT' && smart_bid_type !== 'SMART_BID_NO_BID') {
        const { roi_goal } = params
        if (isEmpty(roi_goal)) err.push({ feild: 'ROI系数', msg: 'ROI系数不能为空' })
        else {
          const roi = Number(roi_goal)
          const min = 0
          const max = 5
          if (roi <= min || roi > max) err.push({ feild: 'ROI系数', msg: `ROI系数应大于${min}，小于等于${max}` })
        }
      }

      // 复制时间问题
      if (schedule_type === 'SCHEDULE_START_END') {
        const now = moment(formatDate(new Date(), 'yyyy-MM-dd 00:00')).valueOf()
        const start = moment(start_time).valueOf()
        const end = moment(end_time).valueOf()
        if (end < now || (start < now && !this.modifieState)) err.push({ feild: '投放时间', msg: '开始时间、结束时间应不小于当前日期' })
      }
      return err
    },
    valid() {
      const rules = [
        {
          name: 'policy/name',
          require: true,
          min: 1,
          max: 40,
          desc: '策略名称'
        },
        {
          name: 'policy/game',
          require: true,
          min: 1,
          desc: '游戏'
        },
        {
          name: 'policy/convert_id',
          require: true,
          desc: '转化追踪类型'
        },
        {
          name: 'policy/budget',
          require: true,
          desc: '预算'
        },
        {
          name: 'policy/app_name',
          require: true,
          min: 4,
          max: 20,
          desc: '应用名'
        },
        {
          name: 'policy/mult_categroy',
          require: true,
          min: 1,
          desc: '创意分类'
        },
        {
          name: 'policy/ad_keywords',
          require: true,
          min: 1,
          max: 20,
          desc: '创意标签'
        },
        {
          name: 'policy/web_url',
          require: true,
          relyon: 'appType',
          relyvalue: true,
          pattern: '^((https|http)?://)[^\\s]+',
          min: 1,
          max: 1024,
          desc: '应用下载详情页',
          msg: '必须以(https://)或(http://)开头的有效橙子建站地址'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    save() {
      this.errRes = [...this.valid(), ...this.customValid(this.policy)]
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }

      const outerPlanParam = pullKeys(
        [
          'delivery_range',
          'download_type',
          'app_type',
          'platform',
          'flow_control_mode',
          'union_video_type',
          'feed_delivery_search',
          'budget',
          'budget_mode',
          'schedule_type',
          'schedule_time',
          'start_time',
          'end_time',
          'pricing',
          'ad',
          'cpa_bid',
          'bid_range',
          'bid_num_range',
          'smart_bid_type',
          'adjust_cpa',
          'deep_bid_type',
          'deep_cpabid',
          'deep_cpabid_range',
          'deep_cpabid_num_range',
          'roi_goal',
          'inventory_type',
          'smart_inventory',
          'inventory_catalog'
        ],
        this.policy
      )
      const creativeParam = pullKeys(
        [
          'inventory',
          'inventory_type',
          'scene_inventory',
          'smart_inventory',
          'third_industry_id',
          'mult_categroy',
          'ad_keywords',
          'web_url',
          'app_name',
          'sub_title',
          'is_comment_disable',
          'close_video_detail',
          'creative_display_mode'
        ],
        this.policy
      )

      const params = {
        id: this.$route.query.id,
        strategyName: this.policy.name,
        platform: this.policy.ch_platform_id,
        gameIdList: this.policy.game,
        convertIndex: this.policy.convert_id,
        outerPlanParam,
        creativeParam
      }
      if (this.policy.schedule_type === 'SCHEDULE_FROM_NOW') {
        delete params.outerPlanParam.start_time
        delete params.outerPlanParam.end_time
      }
      params.outerPlanParam.smart_inventory = params.outerPlanParam.smart_inventory ? 'SMART' : 'NORMAL'
      if (params.outerPlanParam.delivery_range === 'UNION' && params.outerPlanParam.feed_delivery_search) {
        delete params.outerPlanParam.feed_delivery_search
      }
      this.show = false
      this.loading = true
      editPolicy(params).then((data) => {
        this.loading = false
        this.show = true
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 2,
            content: '修改成功！2秒后自动跳转'
          })
          timeout(3000).then(() => {
            this.jump()
          })
        }
      })
    },
    submit() {
      this.errRes = [...this.valid(), ...this.customValid(this.policy)]
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }

      // 'download_url',
      const outerPlanParam = pullKeys(
        [
          'delivery_range',
          'download_type',
          'app_type',
          'platform',
          'flow_control_mode',
          'union_video_type',
          'feed_delivery_search',
          'budget',
          'budget_mode',
          'schedule_type',
          'schedule_time',
          'start_time',
          'end_time',
          'pricing',
          'ad',
          'cpa_bid',
          'bid_range',
          'bid_num_range',
          'smart_bid_type',
          'adjust_cpa',
          'deep_bid_type',
          'deep_cpabid',
          'deep_cpabid_range',
          'deep_cpabid_num_range',
          'roi_goal',
          'inventory_type',
          'smart_inventory',
          'inventory_catalog'
        ],
        this.policy
      )
      const creativeParam = pullKeys(
        [
          'inventory',
          'inventory_type',
          'smart_inventory',
          'scene_inventory',
          'third_industry_id',
          'mult_categroy',
          'ad_keywords',
          'web_url',
          'app_name',
          'sub_title',
          'is_comment_disable',
          'close_video_detail',
          'creative_display_mode'
        ],
        this.policy
      )

      const params = {
        strategyName: this.policy.name,
        platform: this.policy.ch_platform_id,
        gameIdList: this.policy.game,
        convertIndex: this.policy.convert_id,
        outerPlanParam,
        creativeParam
      }

      if (this.policy.schedule_type === 'SCHEDULE_FROM_NOW') {
        delete params.outerPlanParam.start_time
        delete params.outerPlanParam.end_time
      }
      params.outerPlanParam.smart_inventory = params.outerPlanParam.smart_inventory ? 'SMART' : 'NORMAL'
      if (params.outerPlanParam.delivery_range === 'UNION' && params.outerPlanParam.feed_delivery_search) {
        delete params.outerPlanParam.feed_delivery_search
      }

      this.show = false
      this.loading = true
      addPolicy(params).then((data) => {
        this.loading = false
        this.show = true
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 2,
            content: '提交成功！2秒后自动跳转'
          })
          timeout(3000).then(() => {
            this.jump()
          })
        }
      })
    },
    jump() {
      this.$router.push({ name: 'policieslist' })
    },
    cannel() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面编辑信息将丢失，是否确定？</p>',
        onOk: () => {
          this.jump()
        }
      })
    }
  },
  data() {
    return {
      show: null,
      loading: null,
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值

      policy: {
        name: '',
        ch_platform_id: 1,
        group: '',
        game: [],
        delivery_range: 'DEFAULT',
        download_type: 'DOWNLOAD_URL',
        app_type: 'APP_ANDROID',
        platform: 'ANDROID',
        convert_id: '',
        feed_delivery_search: 'DISABLED',

        ad: 'CONVERSION',
        smart_bid_type: 'SMART_BID_CUSTOM', // 手动出价
        adjust_cpa: 1,
        budget_mode: 'BUDGET_MODE_DAY',
        budget: '',
        schedule_type: 'SCHEDULE_FROM_NOW',
        schedule_time: '',
        start_time: '',
        end_time: '',
        time_range: 'NONE',
        flow_control_mode: 'FLOW_CONTROL_MODE_FAST',
        pricing: 'PRICING_OCPM',
        bid_range: 0,
        bid_num_range: null,
        cpa_bid: '',
        deep_bid_type: 'DEEP_BID_DEFAULT',
        deep_cpabid_range: 0,
        deep_cpabid_num_range: null,

        inventory: 'POSITION_AD',
        smart_inventory: 1,
        inventory_type: [],
        mult_categroy: [],
        inventory_catalog: 'SMART',
        third_industry_id: 0,
        ad_keywords: '',
        web_url: '',
        app_name: '',
        sub_title: '',
        is_comment_disable: 0,
        close_video_detail: 0,
        creative_display_mode: 'CREATIVE_DISPLAY_MODE_CTR'
      },
      datetimeOption: { shortcuts, disabledDate }, // 快速选择配置
      datetime: [],
      groupList: [],
      gameList: [],
      convertData: convertData,
      weektimeData: weektimeData,
      categroyData: categroyData,
      opId: 0
    }
  },
  created() {
    this.proload()
    this.policy.schedule_time = getWeektime(this.weektimeData)
    this.policy.start_time = formatDate(new Date(), 'yyyy-MM-dd 00:00')
    this.policy.end_time = formatDate(new Date(Date.parse(new Date()) + 86400000), 'yyyy-MM-dd 23:59')
    this.datetime = [this.policy.start_time, this.policy.end_time]
  },
  watch: {
    weektimeData: {
      handler(nVal) {
        this.policy.schedule_time = getWeektime(nVal)
      },
      deep: true
    },
    'policy.mult_categroy': {
      handler(nVal) {
        if (nVal && nVal.length) {
          this.policy.third_industry_id = nVal[0].id
        }
      },
      deep: true
    },
    'policy.inventory': {
      handler(nVal) {
        if (nVal) {
          if (nVal === 'POSITION_AD') this.policy.inventory_catalog = 'SMART'
          else if (nVal === 'POSITION_SCREEN') this.policy.inventory_catalog = 'SCENE'
          else if (nVal === 'POSITION_MEDIA') this.policy.inventory_catalog = 'MANUAL'
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.c-policy {
  overflow: auto;
  position: relative;
  height: calc(100vh - 160px);

  .row-item {
    align-items: flex-start;
  }

  .item-field {
    height: 32px;
    line-height: 32px;
  }

  .row-item-control {
    margin-top: 8px;
  }

  .row-item-label {
    text-align: right;
    padding: 8px;
  }

  .m-creat-box {
    min-height: 165px;
  }

  .m-download {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    height: 32px;
    line-height: 32px;
  }

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  ::v-deep .ivu-btn {
    margin-left: 8px !important;
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;
    margin-bottom: 20px;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

.split-line {
  margin: 0 10px;
  color: #dcdee2;
}
</style>
